export const FETCH_ALL_HEALTH_TOPICS_SUCCESS =
  "FETCH_ALL_HEALTH_TOPICS_SUCCESS";
export const FETCH_ALL_HEALTH_TOPICS_PENDING =
  "FETCH_ALL_HEALTH_TOPICS_PENDING";
export const FETCH_ALL_HEALTH_TOPICS_ERROR = "FETCH_ALL_HEALTH_TOPICS_ERROR";

export const FETCH_ALL_ARTICLES_SUCCESS = "FETCH_ALL_ARTICLES_SUCCESS";
export const FETCH_ALL_ARTICLES_PENDING = "FETCH_ALL_ARTICLES_PENDING";
export const FETCH_ALL_ARTICLES_ERROR = "FETCH_ALL_ARTICLES_ERROR";

export const FETCH_ARTICLES_UNDER_HEALTH_TOPIC_SUCCESS =
  "Fetch_ARTICLES_UNDER_HEALTH_TOPIC_SUCCESS";
export const FETCH_ARTICLES_UNDER_HEALTH_TOPIC_PENDING =
  "Fetch_ARTICLES_UNDER_HEALTH_TOPIC_PENDING";
export const FETCH_ARTICLES_UNDER_HEALTH_TOPIC_ERROR =
  "Fetch_ARTICLES_UNDER_HEALTH_TOPIC_ERROR";
